// src/components/pages/portfolios/partials/PortfolioTableBody.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

// LockedMetricCell은 지표 락 상태 렌더링을 담당하는 더 작은 컴포넌트
const LockedMetricCell = ({ t, handleLockedMetricClick, styles }) => (
    <span 
      className={styles.lockedMetric} 
      title={t('portfolios.lockedTooltip')}
      onClick={handleLockedMetricClick}
    >
      <FontAwesomeIcon icon={faLock} className={styles.lockIcon} />
    </span>
);

export default function PortfolioTableBody({
    items, hasMore, isFetchingMore, observerTargetRef, navigate, t,
    getReturnValue, getDdValue, getSharpeValue, getCalmarValue, 
    getSortinoValue, getVolValue, handleLockedMetricClick, styles
}) {
    return (
        <tbody>
            {items.map((item) => {
                const isBenchmarkUser = item.userId === 'BENCHMARK';
                const isLazyPort = item.userId === 'LAZYPORT';
                const isBenchmarkFormat = isBenchmarkUser || isLazyPort;
                const isViewButtonHidden = isBenchmarkUser;
                
                let rowClassName = styles.portfolioRow;
                if (isBenchmarkUser) {
                  rowClassName += ` ${styles.benchmarkRow}`;
                } else if (isLazyPort) {
                  rowClassName += ` ${styles.lazyPortRow}`; 
                }
                
                // 지표 값 계산
                const displayedRet = getReturnValue(item).toFixed(2);
                const displayedDd  = getDdValue(item).toFixed(2);
                const displayedVol = getVolValue(item).toFixed(2);
                const displayedSharpe = getSharpeValue(item).toFixed(2);
                const displayedCalmar = getCalmarValue(item).toFixed(2);
                const displayedSortino= getSortinoValue(item).toFixed(2);

                const isMetricsLocked = item.elapsedDays < 0;

                return (
                  <tr key={item.portfolioId} className={rowClassName}>
                    
                    {/* 랭크 */}
                    <td className={styles.rankCell}>{isBenchmarkFormat ? '-' : item.rank}</td>
                    
                    {/* 유저 */}
                    <td className={styles.userCell}>
                        {isLazyPort ? 'LAZYPORT' : 
                         isBenchmarkUser ? 'Benchmark' : 
                         item.nickname || t('portfolios.unnamed')}
                    </td>
                    

                    <td className={styles.nameCell}>{item.name}</td>
                    {/* 수익률, MDD, 변동성 */}
                    <td className={displayedRet>=0?styles.positive:styles.negative}>{displayedRet}%</td>
                    <td className={displayedDd<=0?styles.positive:styles.negative}>{Math.abs(displayedDd)}%</td>
                    <td>{displayedVol}%</td>


                    {/* 샤프 지수 */}
                    <td className={styles.performanceCell}>
                      {isMetricsLocked ? (
                        <LockedMetricCell t={t} handleLockedMetricClick={handleLockedMetricClick} styles={styles} />
                      ) : (
                        <span className={displayedSharpe >= 0 ? styles.positive : styles.negative}>
                          {displayedSharpe}
                        </span>
                      )}
                    </td>
                    {/* 소르티노 지수 */}
                    <td className={styles.performanceCell}>
                      {isMetricsLocked ? (
                        <LockedMetricCell t={t} handleLockedMetricClick={handleLockedMetricClick} styles={styles} />
                      ) : (
                        <span className={displayedSortino >= 0 ? styles.positive : styles.negative}>
                          {displayedSortino}
                        </span>
                      )}
                    </td>
                     {/* 칼마 지수 */}
                     <td className={styles.performanceCell}>
                      {isMetricsLocked ? (
                        <LockedMetricCell t={t} handleLockedMetricClick={handleLockedMetricClick} styles={styles} />
                      ) : (
                        <span className={displayedCalmar >= 0 ? styles.positive : styles.negative}>
                          {displayedCalmar}
                        </span>
                      )}
                    </td>              
                    
                    {/* 경과 일수 */}
                    <td>{item.elapsedDays}{t('portfolios.unit.days')}</td>
                    
                    {/* 보기 버튼 */}
                    <td>
                      {!isViewButtonHidden && (
                        <button onClick={()=>navigate(`/portfolios/${item.portfolioId}`)} className={styles.btnView}>{t('portfolios.viewButton')}</button>
                      )}
                    </td>
                  </tr>
                );
            })}
            {/* 무한 스크롤 옵저버 타겟 */}
            {hasMore && !isFetchingMore && (
                <tr ref={observerTargetRef} className={styles.observerRow}>
                  <td colSpan="11"></td>
                </tr>
            )}
        </tbody>
    );
}